import {
  IField,
  IList,
  IListElement,
} from 'app/services/api5-service/api.interface';

import { ISPFormState } from 'common/dynamic-form/model';
import { isControlHaveBackground } from 'common/dynamic-form/utils/is-control-have-background';

import { IListRowUi } from '../../model';
import { getListCollapse, getListTitle, getListToolbar } from '../../utils';
import { getDataForStub } from '../../utils/get-list-stub';
import { IListHeaderCellUi, IListTableDataUi } from '../model';

/**
 * Get list table data
 *
 * @param elements
 * @param rows
 * @param field
 * @param state
 * @param control
 * @param headerCells
 */
export function getListTableData(
  elements: IListElement[],
  rows: IListRowUi[],
  field: IField,
  state: ISPFormState,
  control: IList,
  headerCells?: IListHeaderCellUi[],
): IListTableDataUi {
  const tableData: IListTableDataUi = {
    type: 'table',
    listName: control.$name,
    title: getListTitle(field, state.docSubject.value),
    collapse: getListCollapse(control, field, state.docSubject.value),
    items: rows,
    hover: control.$hover !== 'no',
    underline: control.$underline !== 'no',
    toolbar: getListToolbar(control, elements, rows, state),
    minWidth: control.$minwidth,
    maxWidth: control.$maxwidth,
    stub: getDataForStub(control, state),
    border:
      control.$row_type !== 'separated' &&
      !isControlHaveBackground(state.docSubject.value, control),
    header:
      control.$type === 'table' && headerCells
        ? {
            cells: headerCells,
          }
        : undefined,
    displayLimit: Number(control.$display_limit),
  };
  return tableData;
}
